import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  createSplitSupplyContract,
  getSplitSupplyContract,
  getSplitSupplyContractFormOptions,
  listSplitSupplyContracts,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 分割供給契約 登録 mutation hook。
 * 成功したら一覧・詳細・登録フォームの候補 (契約済みの地点が出入りする) を最新化する。
 */
export function useCreateSplitSupplyContract(): InvalidatingMutationResultFor<
  typeof createSplitSupplyContract
> {
  return useInvalidatingMutation(createSplitSupplyContract, [
    createConnectQueryKey({
      schema: listSplitSupplyContracts,
      cardinality: 'finite',
    }),
    createConnectQueryKey({
      schema: getSplitSupplyContract,
      cardinality: 'finite',
    }),
    createConnectQueryKey({
      schema: getSplitSupplyContractFormOptions,
      cardinality: 'finite',
    }),
  ])
}
